import { FEATURE_KEYS, visibilityFor, type BusinessTypeId } from "../business-types.js";
import { familyOf } from "../families.js";
import type { LabelSlot, ProfileData, VerticalProfile } from "./types.js";

const NS = "dashboard.nav.typeLabels";

/** Builds the full profile of a type: family and nav come from the matrix, label keys from the slots. */
export function defineProfile(type: BusinessTypeId, data: ProfileData): VerticalProfile {
  const nav = Object.fromEntries(FEATURE_KEYS.map((k) => [k, visibilityFor(type, k)]));
  const labels: Partial<Record<LabelSlot, string>> = {};
  for (const slot of data.labels) labels[slot] = `${NS}.${type}.${slot}`;
  return { ...data, type, family: familyOf(type), nav: nav as VerticalProfile["nav"], labels };
}
